import { createGlobalStyle } from 'styled-components'
import styledNormalize from 'styled-normalize'

import { fonts } from './fonts'
import { scaffolding } from './scaffolding'
import { types } from './types'

export const GlobalStyle = createGlobalStyle`
	${fonts}
	${styledNormalize}
	${scaffolding}
	${types}
`

export * from './fullWidth'
export { responsiveQuery } from './responsiveQuery'
export * from './theme'
export { toRem } from './toRem'
